import { PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IDeal } from "src/@types/deals";
import {
  getCurrentDealAsync,
  createDealFromCloneAsync,
  createDealFromInquiryAsync,
  deleteDealAsync,
  inProgressDealAsync,
  cancelDealAsync,
  doneDealAsync,
} from "./actions";
import { CurrentDealState } from "./slice";

type ActionReducerMapBuilderWithDealState =
  ActionReducerMapBuilder<CurrentDealState>;

export const getDealReducer = (
  builder: ActionReducerMapBuilderWithDealState
) => {
  builder.addCase(getCurrentDealAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(
    getCurrentDealAsync.fulfilled,
    (state, actions: PayloadAction<IDeal>) => {
      state.isLoading = false;
      state.item = actions.payload;
    }
  );

  builder.addCase(getCurrentDealAsync.rejected, (state) => {
    state.isLoading = false;
    state.item = null;
  });
};

export const createDealFromCloneReducer = (
  builder: ActionReducerMapBuilderWithDealState,
) => {
  builder.addCase(createDealFromCloneAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(createDealFromCloneAsync.fulfilled,
    (state) => {
      state.isLoading = false;
    }
  );

  builder.addCase(createDealFromCloneAsync.rejected, (state) => {
    state.isLoading = false;
  }
  );
}

export const createDealFromInquiryReducer = (
  builder: ActionReducerMapBuilderWithDealState,
) => {
  builder.addCase(createDealFromInquiryAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(createDealFromInquiryAsync.fulfilled,
    (state) => {
      state.isLoading = false;
    }
  );

  builder.addCase(createDealFromInquiryAsync.rejected, (state) => {
    state.isLoading = false;
  }
  );
}

export const deleteDealReducer = (
  builder: ActionReducerMapBuilderWithDealState,
) => {
  builder.addCase(deleteDealAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(deleteDealAsync.fulfilled,
    (state) => {
      state.isLoading = false;
    }
  );

  builder.addCase(deleteDealAsync.rejected, (state) => {
    state.isLoading = false;
  }
  );
}

export const inProgressDealReducer = (
  builder: ActionReducerMapBuilderWithDealState,
) => {
  builder.addCase(inProgressDealAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(inProgressDealAsync.fulfilled,
    (state) => {
      state.isLoading = false;

      // CHANGE
      window.location.reload();
    }
  );

  builder.addCase(inProgressDealAsync.rejected, (state) => {
    state.isLoading = false;
  }
  );
}

export const cancelDealReducer = (
  builder: ActionReducerMapBuilderWithDealState,
) => {
  builder.addCase(cancelDealAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(cancelDealAsync.fulfilled,
    (state) => {
      state.isLoading = false;
    }
  );

  builder.addCase(cancelDealAsync.rejected, (state) => {
    state.isLoading = false;
  }
  );
}

export const doneDealReducer = (
  builder: ActionReducerMapBuilderWithDealState,
) => {
  builder.addCase(doneDealAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(doneDealAsync.fulfilled,
    (state) => {
      state.isLoading = false;
    }
  );

  builder.addCase(doneDealAsync.rejected, (state) => {
    state.isLoading = false;
  }
  );
}